import { render, staticRenderFns } from "./SupplierListReject.vue?vue&type=template&id=0894e0c1&"
import script from "./SupplierListReject.vue?vue&type=script&lang=js&"
export * from "./SupplierListReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports